import {NotificationUpdatesInterface} from "../interfaces/notifications/NotificationUpdatesInterface";
import {Notification} from "./Notification";

export class NotificationUpdates implements NotificationUpdatesInterface {
    deleted: string[] = [];
    updated: Notification[] = [];
    updatedAt = '';

    constructor(data: NotificationUpdatesInterface) {
        Object.assign(this, data);
        if (this.updated) {
            this.updated = this.updated.map(item => new Notification(item));
        }
    }

    userIds() {
        return [... new Set(this.updated.map(item => item.data?.userId).filter(Boolean))];
    }
}